export const historySectionDefaultStyle = {
  mainContainerStyle: {
    marginTop: "10px",
    marginBottom: "5px",
    display: "flex",
    flexWrap: "wrap",
  },
  subSectionTitleStyle: {
    fontSize: "small",
    borderLeft: "1px solid grey",
    paddingLeft: "5px",
    marginBottom: "10px",
    pageBreakInside: "avoid",
  },
  subSectionBulletPoint: {
    marginBottom: "5px",
    display: "flex",
    flexDirection: "column",
    pageBreakInside: "avoid",
    fontSize: "small",
  },
};

export const planSectionDefaultStyle = {
  mainContainerStyle: {
    marginTop: "10px",
    marginBottom: "5px",
    display: "flex",
    flexWrap: "wrap",
  },
  bulletPointTitleStyle: {
    fontSize: "small",
    textTransform: "uppercase",
  },
  instructionStyle: {
    fontSize: "small",
    borderLeft: "1px solid grey",
    paddingLeft: "5px",
    marginBottom: "10px",
    pageBreakInside: "avoid",
  },
  subSectionBulletPoint: {
    marginBottom: "5px",
    display: "flex",
    flexDirection: "column",
    pageBreakInside: "avoid",
    fontSize: "small",
  },
};

export const filesSectionDefaultStyle = {
  mainContainerStyle: { marginTop: "10px" },
  subSectionContainerStyle: {
    marginBottom: "5px",
    display: "flex",
    flexWrap: "wrap",
  },
  subSectionStyle: {
    // pageBreakInside: "avoid",
    width: "30vw",
    marginRight: "10px",
    marginBottom: "5px",
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid grey",
    paddingLeft: "5px",
  },
};

export const examinationSectionDefaultStyle = {
  mainContainerStyle: { width: "100%", marginBottom: "5px", marginTop: "10px" },
  tableContainerStyle: {
    display: "flex",
    flexWrap: "nowrap",
    width: "100%",
    // flexDirection: "column",
    gap: "4px",
  },
  notesBulletPointStyle: {
    fontSize: "smaller",
    width: "100%",
  },
  instructionStyle: {
    fontSize: "small",
    borderLeft: "1px solid grey",
    paddingLeft: "5px",
    marginBottom: "10px",
    pageBreakInside: "avoid",
  },
};
